import { selectSelectedObjects } from '%paysera_seat_selection/js/seatSelection/redux/component/workflow/selectors';
import moveObject from './moveObject';
import selectHall from '%paysera_seat_selection/js/seatSelection/redux/component/orm/selectors/selectHall';
import save from '%paysera_seat_selection/js/seatSelection/redux/component/orm/actions/storage/save';
import saveViewBox from '%paysera_seat_selection/js/seatSelection/redux/component/workflow/actions/storage/save';
import calculateHallCacheKey from '%paysera_seat_selection/js/seatSelection/redux/component/orm/actions/calculateHallCacheKey';

function moveSelectedObjects(coordinates) {
    return (dispatch, getState) => {
        const objects = selectSelectedObjects(getState());
        objects.forEach((object) => {
            const { id, objectType } = object;
            dispatch(moveObject({ type: objectType, id, coordinates }));
        });


        const { entityId } = selectHall(getState());
        dispatch(save(entityId));
        dispatch(saveViewBox(entityId));
        dispatch(calculateHallCacheKey());
    };
}

export default moveSelectedObjects;
